import { ViewportScroller } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-case-study-dark-theme',
  templateUrl: './case-study-dark-theme.component.html',
  styleUrls: ['./case-study-dark-theme.component.scss']
})
export class CaseStudyDarkThemeComponent {

  constructor(private viewportScroller: ViewportScroller) { }

  public scrollToSection(elementId: string): void {
    this.viewportScroller.scrollToAnchor(elementId);
  }
}
